//
//
//
//
//
//
//
//
//
//
import SiteAssetStockList from "./SiteAssetStockList";
export default {
  name: 'WasteList',
  components: {
    SiteAssetStockList: SiteAssetStockList
  },
  data: function data() {
    return {};
  }
};